/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { NormativityControllerGetCatalogs200ResponseDataCompaniesInner } from './normativityControllerGetCatalogs200ResponseDataCompaniesInner';


export interface PersonalReductionRequisitionReportControllerGetCatalogs200ResponseData { 
    companies?: Array<NormativityControllerGetCatalogs200ResponseDataCompaniesInner>;
    reductionRequisitionStatus?: Array<NormativityControllerGetCatalogs200ResponseDataCompaniesInner>;
    users?: Array<NormativityControllerGetCatalogs200ResponseDataCompaniesInner>;
}

